import { render, staticRenderFns } from "./EvolucionPlazosProveedores.vue?vue&type=template&id=097bc460&"
import script from "./EvolucionPlazosProveedores.vue?vue&type=script&lang=js&"
export * from "./EvolucionPlazosProveedores.vue?vue&type=script&lang=js&"
import style0 from "./EvolucionPlazosProveedores.vue?vue&type=style&index=0&id=097bc460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports